import React from "react";
import PropTypes from "prop-types";
import {
	Dialog,
	DialogSurface,
	DialogTitle,
	DialogBody,
	DialogActions,
	DialogContent,
	Button,
	Text,
} from "@fluentui/react-components";

/**
 * Reusable Notice Modal for source restrictions / missing documents.
 * Displays user's assigned role(s) dynamically.
 */
const PermissionModal = ({ isOpen, onClose, featureName, userRoles = [] }) => {
	// Join multiple roles with a comma and space: "role1, role2"
	const formattedRoles =
		Array.isArray(userRoles) && userRoles.length > 0
			? userRoles.join(", ")
			: typeof userRoles === "string" && userRoles.trim() !== ""
			? userRoles
			: "No role assigned";

	// Relevant contextual title based on the feature
	const modalTitle =
		featureName === "DocLib"
			? "ℹ️ Document Library Notice"
			: `ℹ️ ${featureName || "Feature"} Notice`;

	return (
		<Dialog
			open={isOpen}
			onOpenChange={(event, data) => !data.open && onClose()}
		>
			<DialogSurface
				style={{ padding: "20px", width: "90vw", maxWidth: "480px" }}
			>
				<DialogBody>
					{/* Replaced '⚠️ Access Denied' with a relevant notice header */}
					<DialogTitle
						style={{
							fontSize: "16px",
							color: "#0078d4",
							display: "flex",
							alignItems: "center",
							gap: "8px",
						}}
					>
						{modalTitle}
					</DialogTitle>

					<DialogContent style={{ marginTop: "12px" }}>
						<Text
							style={{
								fontSize: "13px",
								color: "#323130",
								display: "block",
								lineHeight: "1.6",
							}}
						>
							{featureName === "DocLib" ? (
								<>
									Your role (<strong>{formattedRoles}</strong>) does not
									currently have any processed documents in the Document Library.
									Please contact the AIScribe team.
								</>
							) : (
								<>
									Your role (<strong>{formattedRoles}</strong>) does not have
									access to the <strong>{featureName}</strong> source.
									Please contact the AIScribe team to request access.
								</>
							)}
						</Text>
					</DialogContent>

					<DialogActions style={{ paddingTop: "16px" }}>
						<Button appearance="primary" onClick={onClose}>
							Close
						</Button>
					</DialogActions>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
};

PermissionModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	featureName: PropTypes.string.isRequired,
	userRoles: PropTypes.arrayOf(PropTypes.string),
};

export default PermissionModal;

